import React from 'react';
import { Card, CardContent, CardHeader, Typography, Box, Chip, List, ListItem, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface ERPCardProps {
  system: string;
  status: 'Connected' | 'Disconnected';
  lastSync: string;
  entities: string[];
}

const ERPCard: React.FC<ERPCardProps> = ({ system, status, lastSync, entities }) => {
  const isConnected = status === 'Connected';
  const formattedLastSync = new Date(lastSync).toLocaleString();
  
  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader 
        title={system}
        action={
          <Chip 
            icon={isConnected ? <CheckCircleIcon /> : <ErrorIcon />} 
            label={status} 
            color={isConnected ? 'success' : 'error'} 
          />
        }
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last synchronized: {formattedLastSync}
        </Typography>
        
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            Integrated Entities:
          </Typography>
          <List dense disablePadding>
            {entities.map((entity, index) => (
              <ListItem key={index} disablePadding>
                <ListItemText primary={entity} />
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ERPCard;
